import { inject, Injectable } from '@angular/core';
import { Session, User } from '@supabase/supabase-js';
import { BaseApiService } from './base-api.service';
import { OperationResultService } from '../services/operation-result/operation-result.service';
import { OperationResult } from '../models/operation-result.model';

@Injectable({ providedIn: 'root' })
export class AuthApiService extends BaseApiService {
    private readonly operationResult = inject(OperationResultService);

    async login(
        email: string,
        password: string,
    ): Promise<{ user: User | null; session: Session | null }> {
        const { data, error } = await this.supabase.auth.signInWithPassword({
            email,
            password,
        });

        if (error) throw error;

        return {
            session: data.session ?? null,
            user: data.user ?? null,
        };
    }

    async getSession(): Promise<Session | null> {
        const { data, error } = await this.supabase.auth.getSession();

        if (error) throw error;

        return data.session ?? null;
    }

    async updatePassword(newPassword: string): Promise<OperationResult> {
        try {
            await this.supabase.auth.updateUser({ password: newPassword });
            return this.operationResult.success('UPDATE_PASSWORD');
        } catch (error) {
            this.logger.error(
                'Erreur lors de la mise a jour du mot de passe:',
                error,
            );
            return this.operationResult.error(
                'UPDATE_PASSWORD',
                error as Error,
            );
        }
    }

    async updateHasDefaultPassword(userId: string): Promise<boolean> {
        try {
            await this.supabase.rpc('set_default_password_false', {
                user_id: userId,
            });
            return true;
        } catch (error) {
            this.logger.error(
                "Erreur lors de l'update de has_default_password:",
                error,
            );
            return false;
        }
    }

    async logout(): Promise<void> {
        await this.supabase.auth.signOut();
    }
}
